module.exports = __webpack_public_path__ + "media/sub2-7-4.4933fd52.mp4";